export default "__VITE_ASSET__BTnyNwko__"